import script from "./PortfolioItemComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./PortfolioItemComponent.vue?vue&type=script&lang=ts&setup=true"

import "./PortfolioItemComponent.vue?vue&type=style&index=0&id=138a9b8a&scoped=true&lang=css"

import exportComponent from "/opt/builds/JFRxnycJ/0/firma/firmenwebseite/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-138a9b8a"]])

export default __exports__